import { render, staticRenderFns } from "./CoPilotPromptEditor.vue?vue&type=template&id=3f2e55e4"
import script from "./CoPilotPromptEditor.vue?vue&type=script&lang=js"
export * from "./CoPilotPromptEditor.vue?vue&type=script&lang=js"
import style0 from "./CoPilotPromptEditor.vue?vue&type=style&index=0&id=3f2e55e4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports